import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Row, Card, Button, ListGroup, ListGroupItem, Col } from "react-bootstrap";

export default function ViewSupply() {
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const here = useLocation();

	useEffect(() => {
		setData1(JSON.parse(JSON.stringify(here.state.data1)));
		setData2(JSON.parse(JSON.stringify(here.state.data2)));
		console.log(here.state.data1, here.state.data2);
	}, []);

	return (
		<div>
			<Card
				className="text-center"
				style={{
					marginTop: "30px",
					marginBottom: "40px",
					marginLeft: "auto",
					marginRight: "auto",
					width: "400px",
					boxShadow: "0px 4px 10px",
				}}
			>
				<Card.Header></Card.Header>
				<Card.Body>
					<ListGroup className="list-group-flush">
						<ListGroupItem>UPC: {data2[1]}</ListGroupItem>
						<ListGroupItem>SKU: {data2[0]}</ListGroupItem>
						<ListGroupItem>Factory Information: {data2[4]}</ListGroupItem>
						<ListGroupItem>Manufacturer ID: {data2[3]}</ListGroupItem>
						<ListGroupItem>Distributor ID: {data1[4]}</ListGroupItem>
						<ListGroupItem>Price at which the manufacturer sold the medicine: {data1[2]}</ListGroupItem>
						<ListGroupItem>HOSPITAL ADMIN ID: {data1[5]}</ListGroupItem>
					</ListGroup>
				</Card.Body>
				<Card.Footer className="text-muted"></Card.Footer>
			</Card>
		</div>
	);
}
